import FormWrapper from '@components/search/forms/FormWrapper'
import PartForm from '@components/search/forms/PartForm'
import { frontpageLinks } from '@components/search/formLinks'

const PartSearchpageForm = ({ query }) => {
    return (
        <FormWrapper
            Form={PartForm}
            formLinks={frontpageLinks}
            overrideDefaultValues={query}
            active={5}
            linksOnTop
        />
    )
}

export default PartSearchpageForm